

// import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_API_BASE || "http://localhost:5001/api";

// const api = axios.create({
//   baseURL: API_BASE_URL,
//   withCredentials: true, // cookies
//   headers: { "Content-Type": "application/json" }
// });

// // Interceptor de respuesta para refresh token
// api.interceptors.response.use(
//   response => response,
//   async error => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const { data } = await axios.get(`${API_BASE_URL}/auth/refresh`, { withCredentials: true });
//         localStorage.setItem("token", data.token);
//         originalRequest.headers["Authorization"] = `Bearer ${data.token}`;
//         return axios(originalRequest);
//       } catch (err) {
//         localStorage.clear();
//         window.location.href = "/login";
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;



// //
// import axios from "axios";

// // const API_BASE_URL =
// //   process.env.REACT_APP_API_BASE || "http://localhost:5001/api";

// const API = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";

// const api = axios.create({
//   baseURL: API,
//   withCredentials: true
// });

// /* 🔑 ENVIAR TOKEN EN TODAS LAS PETICIONES */
// api.interceptors.request.use((config) => {

//   const token = localStorage.getItem("token");

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;

// });

// /* REFRESH TOKEN */

// api.interceptors.response.use(
//   response => response,
//   async error => {

//     const originalRequest = error.config;

//     if (error.response?.status === 401 && !originalRequest._retry) {

//       originalRequest._retry = true;

//       try {

//         const { data } = await api.get("/auth/refresh");

//         localStorage.setItem("token", data.token);

//         originalRequest.headers.Authorization = `Bearer ${data.token}`;

//         return api(originalRequest);

//       } catch (err) {

//         localStorage.clear();
//         window.location.href = "/login";

//       }

//     }

//     return Promise.reject(error);

//   }
// );

// export default api;


//

import axios from "axios";
// 1. IMPORTAMOS LA CONFIGURACIÓN CENTRALIZADA
import { API } from "../components/config"; 

const api = axios.create({
  baseURL: API, // <-- Ahora usa "http://3.236.217.225/api" centralizado
  withCredentials: true
});

/* 🔑 ENVIAR TOKEN EN TODAS LAS PETICIONES */
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/* REFRESH TOKEN */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si hay un error 401 y no hemos reintentado aún
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // El interceptor usará automáticamente la baseURL definida arriba
        const { data } = await api.get("/auth/refresh");

        localStorage.setItem("token", data.token);
        originalRequest.headers.Authorization = `Bearer ${data.token}`;

        // Reintentamos la petición original con el nuevo token
        return api(originalRequest);

      } catch (err) {
        // Si el refresh falla, limpiamos todo y al login
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;